<template>
  <div>
    <c-row>
      <c-col>
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>Bootstrap Jumbotron</strong>
            <div class="card-header-actions">
              <a
                href="https://coreui.io/vue/docs/components/jumbotron"
                class="card-header-action"
                rel="noreferrer noopener"
                target="_blank"
              >
                <small class="text-muted">docs</small>
              </a>
            </div>
          </c-card-header>
          <c-card-body>
            <c-jumbotron>
              <h1 class="text-h2">Bootstrap 4</h1>
              <p class="lead">Bootstrap 4 Components for Vue.js 2.6+</p>
              <p>For more information visit website</p>
              <c-button color="primary" href="#">More Info</c-button>
            </c-jumbotron>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col>
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>Jumbotron</strong>
            <small>with slots</small>
          </c-card-header>
          <c-card-body>
            <c-jumbotron header="Bootstrap 4" lead="">
              <h1 class="text-h2">Bootstrap 4</h1>
              <p class="lead">
                This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured
                content or information.
              </p>
              <hr class="my-4" />
              <p>
                It uses utility classes for typography and spacing to space content out within the larger container.
              </p>
              <c-button color="primary" href="#">Do Something</c-button>
              <c-button color="success" href="#">Do Something Else</c-button>
            </c-jumbotron>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col>
        <c-card>
          <c-card-header>
            <c-icon name="cil-justify-center" />
            <strong>Jumbotron</strong>
            <small>colors</small>
          </c-card-header>
          <c-card-body>
            <c-jumbotron color="info" text-color="white" border-color="dark">
              <h1 class="text-h2">Bootstrap 4</h1>
              <p class="lead">
                This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured
                content or information.
              </p>
              <hr class="my-4" />
              <p>
                It uses utility classes for typography and spacing to space content out within the larger container.
              </p>
            </c-jumbotron>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>

<script>
export default {
  name: 'Jumbotrons',
};
</script>
